import { ForemanEquipmentDispatch, ForemanJobDetail } from '@ups/xplat/api/dto';

/**
 * The offline job cache merges remote data with cached priority
 * (`mergeObjectsCachedPriorityMut`), so once an equipment row's `startDate` /
 * `endDate` is cached, a refreshed value from the server is discarded. Those two
 * fields are office-owned scheduling window, not foreman-edited, so a stale
 * cached value can hide still-dispatched equipment from the foreman until the row
 * is corrected by hand (ticket #30171). Overlay the remote dispatch window onto
 * the merged (cached-wins) equipment so an extended/moved date reaches the device.
 *
 * `lastDayOnSite` is deliberately NOT overlaid — it is foreman-owned (set from the
 * device) and must survive the refresh. Rows with no matching remote entry
 * (foreman-created, not yet synced) are left untouched.
 */
export function reconcileEquipmentDatesFromRemoteJob(
  mergedJob: ForemanJobDetail,
  remoteJob: ForemanJobDetail
): void {
  const remoteEqById = new Map(
    (remoteJob.equipment || []).map(
      (eq) =>
        [
          String(eq.foremanEquipmentDispatchID ?? eq.equipmentDispatchID ?? ''),
          eq,
        ] as const
    )
  );

  for (const eq of mergedJob.equipment || []) {
    const id = String(
      eq.foremanEquipmentDispatchID ?? eq.equipmentDispatchID ?? ''
    );
    const remote: ForemanEquipmentDispatch | undefined = id
      ? remoteEqById.get(id)
      : undefined;
    if (!remote) {
      continue;
    }

    eq.startDate = remote.startDate;
    eq.endDate = remote.endDate;
  }
}
